export const HOME = {
  emergentLink: 'home-emergent-link',
};

export const HUMBLE = {
  navHome: 'nav-home',
  navWaitlist: 'nav-waitlist',
  heroHeadline: 'hero-headline',
  heroCta: 'hero-cta-save-seat',
  heroSecondary: 'hero-cta-create-account',
  scrollHint: 'hero-scroll-hint',
  originSection: 'section-origin',
  joySection: 'section-joy-grief',
  capabilitiesSection: 'section-capabilities',
  pullQuote: 'pull-quote-lilies',
  waitlistSection: 'section-waitlist',
  waitlistForm: 'waitlist-form',
  waitlistEmail: 'waitlist-email-input',
  waitlistSubmit: 'waitlist-submit',
  waitlistSuccess: 'waitlist-success',
  waitlistError: 'waitlist-error',
  footer: 'site-footer',
  soliDeoGloria: 'soli-deo-gloria',
  capability: (key) => `capability-${key}`,
};
